module.exports = __webpack_public_path__ + "media/src/images/payment_systems/invoice_en-863dd8f86f6824c7c701e9f3f48e8c57.png";